module.exports = "/assets/data/1d6148a43ac7f04967eb054bd5673617-SW17.data.json";